var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reseted)?_c('div',{staticClass:"video-player"},[_c('video',{ref:"video",staticClass:"video-js",attrs:{"x5-video-player-type":"h5-page","webkit-playsinline":"true","playsinline":"true","x5-video-player-fullscreen":"true"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }